import Termly from 'termly-namespace'

import isBlockableNode from '../isBlockableNode'
import needsBlocking from '../needsBlocking'
import recordLoadedCategories from '../recordLoadedCategories'
import setDataCategories from '../setDataCategories'

import {
  isIframe,
  isScript,
} from '../tagUtils'

import {
  iframeBlocker,
  scriptBlocker,
} from './blockers'


/**
 * @param {MutationRecord[]} mutations
 */
function mutationCallback(mutations) {
  mutations.forEach(({ addedNodes }) => {
    addedNodes.forEach((node) => {
      // This skips over things like text nodes.
      if ( node.nodeType !== Node.ELEMENT_NODE ) {
        return
      }

      if ( !isBlockableNode(node) ) {
        return
      }

      // Adding the data-categories attribute early here allows us to
      // make DOM queries to find elements of interest later on. But if
      // there are already categories in place, we skip this step because
      // those categories were likely put there by the site maintainer as
      // part of manual blocking or category overriding.
      //
      // A paused session stamps nothing. Elsewhere on the page a category
      // reads as a blocking decision, and a pause means we are not making
      // one, so a stamp there hides content we deliberately let through.
      //
      const needsCategories = ( !node.dataset.categories && !Termly.isAutoBlockerPaused() )

      if ( needsCategories ) {
        setDataCategories(node)
      }

      if ( needsBlocking(node) ) {
        if ( isScript(node) ) {
          scriptBlocker(node)
          return
        }

        if ( isIframe(node) ) {
          iframeBlocker(node)
          return
        }

        // A script and an iframe are the only things we know how to block from
        // here. An <img> or an <embed> reaches the line below and loads, whatever
        // category it answers to.
      }

      // Whatever gets this far is loading, so we note what it answers to.
      recordLoadedCategories(node)
    })
  })
}

// TODO: Don't export this object...let the caller construct the
// MutationObserver with the `mutationCallback()` exported above.
export default new MutationObserver(mutationCallback)
